<template>
  <section id="card-text-alignment">
    <section id="search-section">
      <b-row>
        <b-col md="12">
          <b-card>
            <Search></Search>
          </b-card>
        </b-col>
      </b-row>
    </section>

    <section id="items">
      <b-row id="table-hover-row">
        <b-col md="12">

          <b-card>
            <b-row>
              <b-col md="1" class="border-right">

              </b-col>
              <b-col md="2">
                Bizim Resim
              </b-col>

              <b-col md="2">
                Trendyol Resim
              </b-col>

              <b-col md="3">
                Bizim Bilgiler
              </b-col>

              <b-col md="3">
                Trendyol Bilgileri
              </b-col>

            </b-row>
          </b-card>


          <b-card
              v-for="(tyProduct,index) in _products"
              :key="index">
            <Product
                v-for="(product,index2) in tyProduct.products2"
                :key="product.index2"
                :tyProduct="tyProduct"
                :product="product"
            />
          </b-card>
        </b-col>
      </b-row>
    </section>

  </section>
</template>

<script>
import Search from "@/views/trendyol/product/Search";
import Product from "@/views/trendyol/product/Product"
import {mapGetters} from "vuex";

export default {
  name: "ProductHome",
  components: {Search, Product},
  computed: {
    ...mapGetters('tyProduct', ["_products"])
  }
}
</script>

<style scoped>

</style>
